import { TableRow, TableCell, Chip } from "@mui/material";
import { datetimeSimplifier } from "../../redux/conversation/conversationSlice";
import { getSurveyStatusName, SurveyInfo, SurveyStatus, SurveyType } from "../../redux/survey/surveySlice";

interface SurveyRowProps {
  row: SurveyInfo;
  open: (row: SurveyInfo) => void;
}

const SurveyRow = (props: SurveyRowProps) => {
    const row = props.row;

    const open = () => {
        props.open(row);
    };

    const getSurveyTypeName = (type: SurveyType) => {
        switch (type) {
            case SurveyType.GROUP:
                return "Grupo (voto por usuário)";
            case SurveyType.PRIVATE_PER_STUDENT:
                return "Privado, voto por aluno";
            case SurveyType.PRIVATE_PER_USER:
                return "Privado, voto por usuário";
            default:
                return "Desconhecido";
        }
    };

    const getSurveyStatusColor = (theme: any, status: SurveyStatus) => {
        switch (status) {
            case SurveyStatus.NOT_STARTED:
                return theme.palette.warning;
            case SurveyStatus.IN_PROGRESS:
                return theme.palette.info;
            case SurveyStatus.COMPLETED:
                return theme.palette.success;
            default:
                return theme.palette.grey;
        }
    };

    const getTitle = (survey: SurveyInfo) => {
        return survey.questions && survey.questions.length > 0 ? survey.questions[0].title : "Sem título";
    };

    return (
        <TableRow key={row.id}>
            <TableCell align="left" onClick={open}>
                {getSurveyTypeName(row.type)}
            </TableCell>
            <TableCell align="left" onClick={open}>{getTitle(row)}</TableCell>
            <TableCell align="left" onClick={open}>{datetimeSimplifier(row.startAt)}</TableCell>
            <TableCell align="left" onClick={open}>{datetimeSimplifier(row.endAt)}</TableCell>
            <TableCell align="left" onClick={open}>
                <Chip
                    sx={{ 
                        width: "150px",  
                        color: (theme) => getSurveyStatusColor(theme, row.status).contrastText,
                        border: (theme) => `1px solid ${getSurveyStatusColor(theme, row.status).contrastText}`,
                        backgroundColor: (theme) => getSurveyStatusColor(theme, row.status).main,
                    }}
                    label={getSurveyStatusName(row.status)}
                    variant="filled"
                />
            </TableCell>
        </TableRow>
    );
};

export default SurveyRow;
